import * as zod from 'zod';

export const loginFormValidationSchema = zod.object({
  user: zod.string({ required_error: 'Campo obrigatório' }).min(1, 'Informe o usuário'),
  pass: zod.string({ required_error: 'Campo obrigatório' }).min(8, 'Informe uma senha válida'),
});

export type LoginFormData = zod.infer<typeof loginFormValidationSchema>;
